import React from 'react'
import Omega from './Stock.omega'
import Reize from './Stock.reize'
import { SwitchByAppType } from '../../../../browser/components'

const variants = {
  Omega,
  Reize,
}

export default (props) => <SwitchByAppType variants={variants} props={props} />
